var map = {
	"./account.svg": [
		1590,
		70
	],
	"./afternoon.svg": [
		1591,
		71
	],
	"./afterpay.svg": [
		1592,
		72
	],
	"./alert.svg": [
		1593,
		73
	],
	"./apple-store-white.svg": [
		1594,
		75
	],
	"./apple-store.svg": [
		1595,
		74
	],
	"./arrow-diagonal.svg": [
		1596,
		76
	],
	"./arrow-down.svg": [
		1597,
		77
	],
	"./arrow-left.svg": [
		1598,
		78
	],
	"./arrow-pointing-right.svg": [
		1599,
		79
	],
	"./arrow-right.svg": [
		1600,
		80
	],
	"./arrow-up.svg": [
		1601,
		81
	],
	"./ban-icon.svg": [
		1602,
		82
	],
	"./blowdryer.svg": [
		1603,
		83
	],
	"./boxed-calendar.svg": [
		1604,
		84
	],
	"./boxed-check.svg": [
		1605,
		85
	],
	"./boxed-clock.svg": [
		1606,
		86
	],
	"./boxed-drop.svg": [
		1607,
		87
	],
	"./boxed-dropper.svg": [
		1608,
		88
	],
	"./boxed-shop.svg": [
		1609,
		89
	],
	"./calendar-refresh.svg": [
		1610,
		90
	],
	"./calendar.svg": [
		1611,
		91
	],
	"./camera.svg": [
		1612,
		92
	],
	"./caret-down.svg": [
		1613,
		93
	],
	"./caret-rounded.svg": [
		1614,
		94
	],
	"./chair.svg": [
		1615,
		95
	],
	"./chat-2.svg": [
		1616,
		96
	],
	"./chat.svg": [
		1617,
		97
	],
	"./check-circle-empty.svg": [
		1618,
		98
	],
	"./check-circle-filled.svg": [
		1619,
		99
	],
	"./check-circle-solid.svg": [
		1620,
		100
	],
	"./check-circle.svg": [
		1621,
		101
	],
	"./check-icon.svg": [
		1622,
		102
	],
	"./checkmark.svg": [
		1623,
		103
	],
	"./circle-arrow.svg": [
		1624,
		104
	],
	"./circle-camera.svg": [
		1625,
		105
	],
	"./clock.svg": [
		1626,
		106
	],
	"./coily-hair.svg": [
		1627,
		107
	],
	"./color-kit.svg": [
		1628,
		108
	],
	"./color-plus-line-icon.svg": [
		1629,
		109
	],
	"./colorwonder-logo.svg": [
		1630,
		110
	],
	"./comb.svg": [
		1631,
		111
	],
	"./cross-icon.svg": [
		1632,
		112
	],
	"./curly-hair.svg": [
		1633,
		113
	],
	"./cw-check.svg": [
		1634,
		114
	],
	"./cw-message.svg": [
		1635,
		115
	],
	"./dollar-circle.svg": [
		1636,
		116
	],
	"./doordash.svg": [
		1637,
		117
	],
	"./email.svg": [
		1638,
		118
	],
	"./enlarge.svg": [
		1639,
		119
	],
	"./evening.svg": [
		1640,
		120
	],
	"./gift.svg": [
		1641,
		121
	],
	"./google-play-white.svg": [
		1642,
		123
	],
	"./google-play.svg": [
		1643,
		122
	],
	"./green-check.svg": [
		1644,
		124
	],
	"./hair-color-circles.svg": [
		1645,
		125
	],
	"./hair.svg": [
		1646,
		126
	],
	"./heart-ribbon.svg": [
		1647,
		127
	],
	"./heart.svg": [
		1648,
		128
	],
	"./info-icon.svg": [
		1649,
		129
	],
	"./info.svg": [
		1650,
		130
	],
	"./left-pointing-arrow.svg": [
		1651,
		131
	],
	"./less.svg": [
		1652,
		132
	],
	"./light-bulb.svg": [
		1653,
		133
	],
	"./location.svg": [
		1654,
		134
	],
	"./logout.svg": [
		1655,
		135
	],
	"./mail-circle.svg": [
		1656,
		136
	],
	"./map-circle.svg": [
		1657,
		137
	],
	"./map-marker-base.svg": [
		1658,
		138
	],
	"./map-marker-inverted.svg": [
		1659,
		139
	],
	"./map-marker.svg": [
		1660,
		140
	],
	"./mdsnrd-vertical.svg": [
		1661,
		141
	],
	"./mic-off.svg": [
		1662,
		142
	],
	"./mic.svg": [
		1663,
		143
	],
	"./mirror.svg": [
		1664,
		144
	],
	"./money-back-redesign.svg": [
		1665,
		145
	],
	"./money-back.svg": [
		1666,
		146
	],
	"./money-hand.svg": [
		1667,
		147
	],
	"./more.svg": [
		1668,
		148
	],
	"./morning.svg": [
		1669,
		149
	],
	"./mr-haircolor-logo.svg": [
		1670,
		150
	],
	"./mr-icon-chat.svg": [
		1671,
		151
	],
	"./mr-logo.svg": [
		1672,
		152
	],
	"./mr-mister-logo.svg": [
		1673,
		153
	],
	"./pause.svg": [
		1674,
		154
	],
	"./phone-circle.svg": [
		1675,
		155
	],
	"./phone-handset.svg": [
		1676,
		156
	],
	"./phone.svg": [
		1677,
		157
	],
	"./pin.svg": [
		1678,
		158
	],
	"./plus-circle.svg": [
		1679,
		159
	],
	"./plus.svg": [
		1680,
		160
	],
	"./profile.svg": [
		1681,
		161
	],
	"./ribbon-crown.svg": [
		1682,
		162
	],
	"./ribbon-plus.svg": [
		1683,
		163
	],
	"./roots-hair.svg": [
		1684,
		164
	],
	"./salon.svg": [
		1685,
		165
	],
	"./search-2.svg": [
		1686,
		166
	],
	"./search.svg": [
		1687,
		167
	],
	"./settings.svg": [
		1688,
		168
	],
	"./shampoo-and-conditioner.svg": [
		1689,
		169
	],
	"./shield.svg": [
		1690,
		170
	],
	"./shiny-hair.svg": [
		1691,
		171
	],
	"./shop.svg": [
		1692,
		172
	],
	"./spinner-v2-white.svg": [
		1693,
		174
	],
	"./spinner-v2.svg": [
		1694,
		173
	],
	"./star-octagon-filled.svg": [
		1695,
		175
	],
	"./star-octagon.svg": [
		1696,
		176
	],
	"./star.svg": [
		1697,
		177
	],
	"./stars-filled.svg": [
		1698,
		178
	],
	"./stars.svg": [
		1699,
		179
	],
	"./straight-hair.svg": [
		1700,
		180
	],
	"./switch.svg": [
		1701,
		181
	],
	"./tag.svg": [
		1702,
		182
	],
	"./tick.svg": [
		1703,
		183
	],
	"./times-circle-solid.svg": [
		1704,
		184
	],
	"./trash.svg": [
		1705,
		185
	],
	"./truck.svg": [
		1706,
		186
	],
	"./trust.svg": [
		1707,
		187
	],
	"./tube-and-bottle.svg": [
		1708,
		188
	],
	"./tube-and-brush.svg": [
		1709,
		189
	],
	"./tube-and-comb.svg": [
		1710,
		190
	],
	"./tube.svg": [
		1711,
		191
	],
	"./unlimited-roots-membership-comb-icon.svg": [
		1712,
		192
	],
	"./video-camera-light.svg": [
		1713,
		193
	],
	"./video-chat.svg": [
		1714,
		194
	],
	"./video-off.svg": [
		1715,
		195
	],
	"./video.svg": [
		1716,
		196
	],
	"./waving-hand.svg": [
		1717,
		197
	],
	"./wavy-hair.svg": [
		1718,
		198
	],
	"./zoom-in.svg": [
		1719,
		199
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1120;
module.exports = webpackAsyncContext;